export default __webpack_public_path__ + "static/connatix-898b685b66e3e56041a23c41cd4d1ed3.svg";